<template>
    <span v-if="token != null">
        <v-avatar icon :size="size" class="pointer">
            <v-icon v-if="!user.avatar" color="primary" aria-label="account-circle-outline" icon="mdi:mdi-account-circle-outline" :size="size"></v-icon>
            <v-img v-if="user.avatar" :src="user.avatar" cover :height="size"></v-img>
            <v-menu :model-value="menu" activator="parent" width="220" transition="slide-y-transition" @update:modelValue="updateModelValue">
                <v-list bg-color="black">
                    <v-list-item>
                        <v-list-item-title class="gradient-underline-hover ">
                            <v-icon icon="mdi:mdi-wallet-outline" aria-label="mdi-wallet-outline" class="mr-3 text-primaryGrey"></v-icon>
                            <Clipboard :text="user.wallet">
                                <span class="text-primaryGrey gradient-text-hover">{{ $tools.privacyField(user.wallet) }}</span>
                            </Clipboard>
                        </v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <!-- 用户 -->
                    <v-list-item v-for="(menu, index) in userMenus" :key="index" :value="index">
                        <router-link :to="menu.to" class="del-underline text-primaryGrey">
                            <v-list-item-title class="gradient-underline-hover">
                                <v-icon :icon="menu.icon" aria-label="menu" class="text-primaryGrey"></v-icon>
                                <a class="ml-3 gradient-text-hover text-primaryGrey">{{ menu.title }}</a>
                            </v-list-item-title>
                        </router-link>
                    </v-list-item>
                    <v-divider></v-divider>
                    <!-- Crypto -->
                    <div class="ml-2 my-3 text-primaryGrey body-h4">CRYPTOS</div>
                    <v-list-item>
                        <a href="/uncrypto/wrap" class="del-underline" :class="cryptoWrapPermission ? 'text-primaryGrey' : 'text-lightGray pointer-none'">
                            <v-list-item-title class="gradient-underline-hover">
                                <v-icon icon="mdi:mdi-plus-thick" aria-label="mdi:mdi-plus-thick" :class="cryptoWrapPermission ? 'text-primaryGrey' : 'text-lightGray pointer-none'"></v-icon>
                                <a class="ml-3 gradient-text-hover" :class="cryptoWrapPermission ? 'text-primaryGrey' : 'text-lightGray pointer-none'">Wrap Crypto</a>
                            </v-list-item-title>
                        </a>
                    </v-list-item>
                    <v-divider></v-divider>
                    <!-- NFT -->
                    <div class="ml-2 my-3 text-primaryGrey body-h4">NFTS</div>
                    <v-list-item v-for="(menu, index) in nftMenus" :key="index" :value="index">
                        <router-link :to="menu.to" class="del-underline text-primaryGrey">
                            <v-list-item-title class="gradient-underline-hover">
                                <v-icon :icon="menu.icon" aria-label="menu" class="text-primaryGrey"></v-icon>
                                <a class="ml-3 gradient-text-hover text-primaryGrey">{{ menu.title }}</a>
                            </v-list-item-title>
                        </router-link>
                    </v-list-item>
                    <v-divider></v-divider>
                    <!-- 系统 -->
                    <v-list-item v-for="(menu, index) in systemMenus" :key="index" :value="index">
                        <router-link :to="menu.to" class="del-underline text-primaryGrey">
                            <v-list-item-title class="gradient-underline-hover">
                                <v-icon :icon="menu.icon" aria-label="menu" class="text-primaryGrey"></v-icon>
                                <a class="ml-3 gradient-text-hover text-primaryGrey">{{ menu.title }}</a>
                            </v-list-item-title>
                        </router-link>
                    </v-list-item>
                    <!-- 退出 -->
                    <v-list-item>
                        <v-list-item-title class="gradient-underline-hover pointer" @click="logout">
                            <v-icon icon="mdi:mdi-logout-variant" aria-label="logout-variant" class="text-primaryGrey"></v-icon>
                            <a class="ml-3 gradient-text-hover text-primaryGrey">Log Out</a>
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-avatar>
        <span v-if="showName" class="gradient-underline-hover" :class="textColor">
            <a class="ml-3 gradient-text-hover text-primaryGrey">{{ user?.name }}</a>
        </span>
    </span>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    props: {
        menu: {
            type: Boolean,
            default: false
        },
        size: {
            type: Number,
            default: 36
        },
        showName: {
            type: Boolean,
            default: false
        },
        textColor: {
            type: String,
            default: 'text-primaryGrey'
        },
    },
    data(){
        return {

        }
    },
    components: {  },
    created(){

    },
    mounted(){

    },
    computed: {
        ...mapGetters(['token', 'user', 'cryptoWrapPermission']),
        userMenus(){ 
            return [
                { title: 'Profile', icon: 'mdi:mdi-account', to: '/profile/' + this.user.username },
                { title: 'Dashboard', icon: 'mdi:mdi-view-dashboard-outline', to: '/dashboard' },
            ]
        },
        nftMenus() {
            return [
                { title: 'Create Set', icon: 'mdi:mdi-image-multiple-outline', to: '/set/create' },
                { title: 'Import unNFT', icon: 'mdi:mdi-image-check-outline', to: '/unnft/import' },
                { title: 'Create unNFT', icon: 'mdi:mdi-image-plus-outline', to: '/unnft/mint' },
                { title: 'Wrap NFT', icon: 'mdi:mdi-image-refresh-outline', to: '/unnft/wrap' },
                { title: 'Create Collection', icon: 'mdi:mdi-file-multiple-outline', to: '/collection/create' },
            ]
        },
        systemMenus(){ 
            return [
                { title: 'Settings', icon: 'mdi:mdi-cog', to: '/settings' }
            ]
        },
    },
    watch:{

    },
    methods: {
        updateModelValue(menu) {
            this.$emit('watchAvatarMenu', menu);
        },
        logout(){
            this.$store.commit("tokenHandler", null);
            this.$router.push("/uncryptos");
            setTimeout(() => location.reload(), 100);
        }
    }
}
</script>
<style scoped>

</style>